import Vue from 'vue'
import App from './App.vue'
import './globals/config';
import router from './router'
import store from './store'
import i18n from './i18n'

// plugins init
import './plugins/vue-snotify'
import './plugins/vue-loading-overlay'
import './plugins/bootstrap-vue'

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
